import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticationService } from '../../../@core/services/authentication.service';
import { MatDialogRef } from '@angular/material';
import { MobileUser } from '../../../@core/models/MobileUser';
import { Subscription } from 'rxjs';
import { SectorService } from '../../../@core/services/sector.service';
import { RouteService } from '../../../@core/services/route.service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  AbstractControl
} from '@angular/forms';
import { DashboardBase } from '../../../pages/auth/dashboard/dashboard.base';

@Component({
  selector: 'ngx-transfert-sector-dialog',
  templateUrl: './transfert-sector-dialog.component.html',
  styleUrls: ['./transfert-sector-dialog.component.scss']
})
export class TransfertSectorDialogComponent extends DashboardBase {
  selectedSector: any;
  date: Date;

  ngOnInit(): void {
    this.date = new Date();
  }

  selectSector(sector: any) {
    this.selectedSector = sector;
  }

  transfert() {
    this.Batchmove(this._stopService.selectedStops, this.selectedSector, 1, 2);
  }
}
